import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  Container: {
    marginLeft: '25px',
    marginRight: '25px',
  },
  Field: {
    display: 'grid',
    padding: '10px',
  },
  Bold: {
    fontWeight: 'bold',
  },
  UpperCase: {
    textTransform: 'uppercase',
  },
  EventTypeForm: {
    borderBottom: '1px solid lightgray',
  },
  SaveAllButton: {
    marginTop: '10px',
  },
  Wide: {
    width: '100%',
  },
  tableHeaderLabel: {
    marginBottom: '10px',
    display: 'block',
  },
  tableHeader: {
    backgroundColor: '#f1f1f1',
    padding: '5px 0',
  },
  tableWrapper: {
    border: '1px solid #f1f1f1',
    height: 'calc(100vh - 600px)',
    overflowY: 'auto',
    maxHeight: '530px',
    margin: '0',
    '@media (min-width: 600px)': {
      height: 'calc(100vh - 435px)',
    },
    '@media (min-width: 960px)': {
      height: 'calc(100vh - 350px)',
    },
    '@media (min-width: 1280px)': {
      height: 'calc(100vh - 265px)',
    },
  },
  checkboxWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    '& label': {
      margin: 0,
    },
  },
});
